import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { azure } from '../environments/environment.prod';


export function msalInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: azure.clientId,
      authority: `https://login.microsoftonline.com/${azure.tenantId}`,
      redirectUri: azure.redirectUri,
      postLogoutRedirectUri: azure.redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return; // never log personally identifiable info
          switch (level) {
            case LogLevel.Error:
              console.error('[MSAL]', message);
              break;
            case LogLevel.Warning:
              console.warn('[MSAL]', message);
              break;
            case LogLevel.Info:
              console.log('[MSAL]', message);
              break;
          }
        },
        logLevel: LogLevel.Warning,
      },
    },
  });
}


export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['openid', azure.scope],
    },
  };
}


export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  // All requests to your backend APIs will get the Microsoft token attached
  // These patterns match your proxy-dev.conf.json service endpoints
  protectedResourceMap.set('/web-app-svc/*', [azure.scope]);
  protectedResourceMap.set('web-app-svc/*', [azure.scope]);
  protectedResourceMap.set('/auth-svc/*', [azure.scope]);
  protectedResourceMap.set('auth-svc/*', [azure.scope]);
  protectedResourceMap.set('/meter-data-svc/*', [azure.scope]);
  protectedResourceMap.set('meter-data-svc/*', [azure.scope]);
  protectedResourceMap.set('/live-meter-svc/*', [azure.scope]);
  protectedResourceMap.set('live-meter-svc/*', [azure.scope]);
  protectedResourceMap.set('/mso-hierarchy-svc/*', [azure.scope]);
  protectedResourceMap.set('mso-hierarchy-svc/*', [azure.scope]);
  protectedResourceMap.set('/channel-map-svc/*', [azure.scope]);
  protectedResourceMap.set('channel-map-svc/*', [azure.scope]);
  protectedResourceMap.set('/workorder-svc/*', [azure.scope]);
  protectedResourceMap.set('workorder-svc/*', [azure.scope]);
  protectedResourceMap.set('/rma-svc/*', [azure.scope]);
  protectedResourceMap.set('rma-svc/*', [azure.scope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
